import { INDIVIDUAL } from './_http';
import { queryString } from '../../helpers';

const getNetworks = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Products/${form.product}/Plans/${form.plan}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getBenefitGroups = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Products/${form.product}/Plans/${form.plan}/benefitgroups`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getBenefitDetail = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Claims/RemaningLimit?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getClaimStatuses = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/H4AParams/ClaimStatuses`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getClaims = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Claims?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getExemptions = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Policies/${form.policy}/Insureds/${form.customer}/Exemptions`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const policyPrints = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Agito/Prints`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getNetworks, getBenefitGroups, getBenefitDetail, getClaimStatuses, getClaims, getExemptions,policyPrints }